import React from "react";
import { Link } from "react-router-dom";

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-section">
          <h3>Neurovasc</h3>
          <p>Leading Medical Technology</p>
          <p>Innovative Solutions, Reliable Results</p>
        </div>

        <div className="footer-section">
          <h3>Quick Links</h3>
          <ul>
            <li>
              <Link to="/">Home</Link>
            </li>
            <li>
              <Link to="/about">About</Link>
            </li>
          
            <li>
              <Link to="/products">Products</Link>
            </li>
            <li>
              <Link to="/contact">Contact</Link>
            </li>
            <li>
              <Link to="/modern-slavery">Modern Slavery Statement</Link>
            </li>
            <li>
              <Link to="/carbon-reduction-plan">Carbon Reduction Plan</Link>
            </li>
          </ul>
        </div>

        <div className="footer-section">
          <h3>Products</h3>
          <ul>
            <li>
              <Link to="/products?product=proender">Proender®</Link>
            </li>
            <li>
              <Link to="/products?product=perrdenser">Perdenser™</Link>
            </li>
            <li>
              <Link to="/products?product=freepass">Freepass®</Link>
            </li>
            <li>
              <Link to="/products?product=perfiller">Perfiller®</Link>
            </li>
          </ul>
        </div>

        <div className="footer-section">
          <h3>Contact</h3>
          <p>
            Email: <a href="mailto:info@neurovasc.co.uk">info@neurovasc.co.uk</a>
          </p>
          <p>
            Phone: <a href="tel:+447976888630">07976 888630</a>
          </p>
          <p>
            Address: <Link to="/contact">RH12 3XX Horsham, West Sussex, England</Link>
          </p>
        </div>
      </div>

      <div className="footer-bottom">
        <p>&copy; {new Date().getFullYear()} Neurovasc. All rights reserved.</p>
      </div>
    </footer>
  );
}

export default Footer;
